var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{staticClass:"my-0 py-0 nav-section",style:({color: `${_vm.getColor('baColorGray4')} !important`})},[(!_vm.mini)?_vm._t("default"):_vm._t("mini")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }